import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabbookinginpune() {



const cardData = {
  keyword: " Cab Booking in Pune ",

"headingDescription": "SRS Cab Service offers Cab Booking in Pune, providing a quick, reliable, and comfortable travel solution for daily commuting, airport transfers, and outstation journeys. Our well-maintained vehicles, professional drivers, and easy booking process ensure a smooth and hassle-free experience across Pune city. Whether you need a cab for business travel, family outings, or local sightseeing, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and stress-free ride.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort and one of Pune’s most iconic landmarks. Travelers using Cab Booking in Pune from SRS Cab Service often visit to explore its grand architecture and historical significance."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is an important historical monument linked to India’s freedom movement. Visitors using SRS Cab Service often explore its gardens and museum exhibits."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a popular hill fort known for scenic views and trekking. Travelers using SRS Cab Service often include this destination for adventure and sightseeing."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered religious sites. Visitors using SRS Cab Service often visit to seek blessings and spiritual peace."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva. Travelers using SRS Cab Service often enjoy its peaceful ambiance and historical importance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses a vast collection of Indian artifacts. Visitors using SRS Cab Service often explore Pune’s cultural heritage here."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple offers panoramic views of Pune along with historic temples. Travelers using SRS Cab Service often visit for sightseeing and relaxation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a scenic and peaceful destination near Pune. Visitors using SRS Cab Service often include this spot for leisure and photography."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden is a beautifully landscaped Japanese-style garden. Travelers using SRS Cab Service often enjoy its greenery and calm environment."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic palace associated with Chhatrapati Shivaji Maharaj. Visitors using SRS Cab Service often explore this landmark to learn about Pune’s rich history."
  }
],



services: [
{
name: "One Way Cab Pune",
description: "One way cab Pune offers economical travel without return charges. Customers can book direct rides for long-distance trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "Best Outstation Cab Service in Pune",
description: "Best outstation cab service in Pune offers top-rated transportation for long-distance travel. Customers can enjoy reliable and comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Outstation Cab Service in Pune",
description: "Outstation cab service in Pune provides dependable transportation for intercity travel. Customers can book cabs for tours and business trips. Professional drivers ensure safe highway journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi in Pune for Outstation",
description: "Taxi in Pune for outstation offers convenient travel for long-distance journeys. Customers can book taxis for flexible trips. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Taxi Service in Pune for Outstation",
description: "Taxi service in Pune for outstation provides reliable transportation for intercity travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune offers reliable transportation for local and outstation travel. Customers can book cabs for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi in Pune",
description: "Taxi in Pune provides convenient travel for city rides and airport transfers. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Shirdi Cab Booking Service",
description: "Pune to Shirdi cab booking service offers easy travel for temple visits. Customers can book cabs for pilgrimage journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily to Shirdi with cab services."
},
{
name: "Best Cab Service in Pune",
description: "Best cab service in Pune offers top-rated transportation for daily and outstation travel. Customers can enjoy reliable and comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with best cab services."
},
{
name: "Online Cab Booking Pune",
description: "Online cab booking Pune provides quick and easy reservation options. Customers can book cabs instantly through online platforms. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Pune to Mumbai Cheapest Cab",
description: "Pune to Mumbai cheapest cab offers budget-friendly travel for intercity trips. Customers can book cabs at affordable prices. Professional drivers ensure safe highway journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with cheapest cab services."
},
{
name: "Outstation Taxi Service Pune",
description: "Outstation taxi service Pune offers reliable travel for long-distance journeys. Customers can book taxis for tours and business trips. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune Airport to Shirdi Cab",
description: "Pune airport to Shirdi cab offers convenient travel for temple visits. Customers can book cabs for direct airport pickup and drop. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Taxi Services in Pune",
description: "Taxi services in Pune provide reliable transportation for local and outstation travel. Customers can book taxis for daily and business trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Shirdi Cab Booking",
description: "Pune to Shirdi cab booking offers quick reservation options for travelers. Customers can book cabs online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily for Shirdi travel."
},
{
name: "Cab from Pune to Shirdi",
description: "Cab from Pune to Shirdi provides reliable transportation for temple visits. Customers can book cabs for comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily to Shirdi with cab services."
},
{
name: "Pune to Shirdi Cab Price",
description: "Pune to Shirdi cab price provides estimated cost details for travel planning. Customers can compare prices before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab price services."
},
{
name: "Pune to Bhimashankar Cab Fare",
description: "Pune to Bhimashankar cab fare provides pricing details for temple travel. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab fare services."
},
{
name: "Pune to Ahmednagar Cab",
description: "Pune to Ahmednagar cab offers reliable transportation for intercity travel. Customers can book cabs for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Goa Taxi",
description: "Pune to Goa taxi offers comfortable long-distance travel for vacations. Customers can book taxis for beach trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Mumbai Cab Booking",
description: "Pune to Mumbai cab booking provides quick reservation options for travelers. Customers can book cabs online or offline. Professional drivers ensure safe highway journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily."
},
{
name: "Pune Cab Booking",
description: "Pune cab booking offers easy travel solutions for local and outstation trips. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily in Pune."
},
{
name: "Cab Booking Pune Online",
description: "Cab booking Pune online provides instant booking options for customers. Travelers can reserve cabs quickly through digital platforms. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily online."
},
{
name: "Taxi Booking Pune Online",
description: "Taxi booking Pune online offers convenient booking solutions for daily travel. Customers can book taxis instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily online."
},
{
name: "Best Cab Booking in Pune",
description: "Best cab booking in Pune offers top-rated reservation services for customers. Travelers can enjoy reliable and smooth booking experience. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily."
},
{
name: "Cheap Cab Booking Pune",
description: "Cheap cab booking Pune provides budget-friendly travel booking options. Customers can book cabs at affordable prices. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Book your cab easily with cheap services."
},
{
name: "Affordable Cab Booking Pune",
description: "Affordable cab booking Pune offers cost-effective booking solutions for daily travel. Customers can book cabs at competitive prices. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Book your cab easily."
},
{
name: "Instant Cab Booking Pune",
description: "Instant cab booking Pune provides quick and hassle-free booking options. Customers can book cabs instantly for urgent travel needs. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab instantly in Pune."
}
],

tableData: [
["One Way Cab Pune","Best Outstation Cab Service in Pune"],
["Outstation Cab Service in Pune","Taxi in Pune for Outstation"],
["Taxi Service in Pune for Outstation","Cab Service in Pune"],
["Taxi in Pune","Pune to Shirdi Cab Booking Service"],
["Best Cab Service in Pune","Online Cab Booking Pune"],
["Pune to Mumbai Cheapest Cab","Outstation Taxi Service Pune"],
["Pune Airport to Shirdi Cab","Taxi Services in Pune"],
["Pune to Shirdi Cab Booking","Cab from Pune to Shirdi"],
["Pune to Shirdi Cab Price","Pune to Bhimashankar Cab Fare"],
["Pune to Ahmednagar Cab","Pune to Goa Taxi"],
["Pune to Mumbai Cab Booking","Pune Cab Booking"],
["Cab Booking Pune Online","Taxi Booking Pune Online"],
["Best Cab Booking in Pune","Cheap Cab Booking Pune"],
["Affordable Cab Booking Pune","Instant Cab Booking Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Easy & Quick Cab Booking in Pune",
    WhyChoosedescription: "SRS Cab Service offers fast and hassle-free cab booking in Pune through online and phone booking options, making travel convenient anytime."
  },
  {
    WhyChooseheading: "Affordable Cab Booking Services",
    WhyChoosedescription: "We provide budget-friendly cab booking in Pune with transparent pricing. Customers receive clear fare details with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7, allowing customers to book cabs anytime for local travel, airport transfers, and outstation trips."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Options",
    WhyChoosedescription: "Choose from hatchbacks, sedans, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for all travel needs."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles ensuring a smooth and comfortable ride across Pune."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide pickup from homes, hotels, offices, and Pune Airport across all areas including Hinjewadi, Kharadi, Viman Nagar, and Hadapsar."
  },
  {
    WhyChooseheading: "Professional & Verified Drivers",
    WhyChoosedescription: "Our experienced drivers ensure safe driving, polite behavior, and a reliable travel experience for every ride."
  },
  {
    WhyChooseheading: "Trusted Cab Booking Service in Pune",
    WhyChoosedescription: "SRS Cab Service is trusted for cab booking in Pune due to punctual service, affordable pricing, and excellent customer satisfaction."
  }
]
}

const faqData = [
  { question: "How can I book a cab in Pune?", answer: "You can book a cab in Pune easily through online booking or by calling SRS Cab Service." },
  { question: "Is cab booking available in Pune 24 hours?", answer: "Yes, our cab booking service operates 24/7 for all travel needs." },
  { question: "Which vehicles are available for booking?", answer: "We offer hatchbacks, sedans, SUVs, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Do you provide airport cab booking in Pune?", answer: "Yes, we provide Pune Airport pickup and drop services." },
  { question: "Can I book cab for outstation travel?", answer: "Yes, we provide cab booking for both local and outstation travel." },
  { question: "Is one-way cab booking available?", answer: "Yes, we provide one-way and round-trip cab booking services." },
  { question: "Are drivers professional?", answer: "Yes, all drivers are trained, experienced, and verified." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Patil",
    feedback:
      "Booked cab in Pune through SRS. Very easy booking process and smooth ride.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Sharma",
    feedback:
      "Best cab booking service in Pune. Clean car, on-time pickup, and professional driver.",
    rating: 5
  }
];



























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];













const jsonData = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Cab Booking in Pune - SRS Cab & Tours",
  "description": "Book cabs in Pune online for local rides, one-way trips, outstation travel, and airport transfers. Affordable and reliable taxi services in Pune.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/cab-booking-pune",
  "areaServed": [
    "Pune, Maharashtra",
    "Shirdi",
    "Mumbai",
    "Goa",
    "Bhimashankar",
    "Ahmednagar"
  ],
  "openingHours": "Mo-Su 06:00-22:00",
  "priceRange": "₹₹",
  "serviceType": [
    "Cab Booking in Pune",
    "One Way Cab Pune",
    "Outstation Cab Service Pune",
    "Airport Taxi Pune",
    "Pune Local Cab",
    "Online Cab Booking Pune"
  ],
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1240"
  }
};




  return (
    <div>
      

<Helmet>
  <title>Cab Booking in Pune | SRS Cab & Tours</title>
  <meta 
    name="description" 
    content="Book cabs in Pune online for local rides, outstation trips, airport transfers, and one-way journeys. Affordable, reliable, and best cab service in Pune." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/57.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabbookinginpune;